import { useEffect, useState } from 'react'

import {
    CABIN_MEDIA_DRAWER_PANEL_BORDER_RADIUS_PX,
    CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX,
    CABIN_MEDIA_DRAWER_PANEL_WIDTH_TO_HEIGHT_RATIO,
    CABIN_MEDIA_DRAWER_VERTICAL_MARGIN_PX,
} from './constants'

export type CabinMediaPanelSize = {
    height: number
    width: number
    borderRadius: number
}

const getPanelSize = (): CabinMediaPanelSize => {
    if (typeof window === 'undefined') {
        return {
            height: CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX,
            width: CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX * CABIN_MEDIA_DRAWER_PANEL_WIDTH_TO_HEIGHT_RATIO,
            borderRadius: CABIN_MEDIA_DRAWER_PANEL_BORDER_RADIUS_PX,
        }
    }

    const availableHeight = window.innerHeight - CABIN_MEDIA_DRAWER_VERTICAL_MARGIN_PX * 2
    const height = Math.min(CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX, availableHeight)
    const width = height * CABIN_MEDIA_DRAWER_PANEL_WIDTH_TO_HEIGHT_RATIO
    const scale = height / CABIN_MEDIA_DRAWER_PANEL_MAX_HEIGHT_PX
    const borderRadius = CABIN_MEDIA_DRAWER_PANEL_BORDER_RADIUS_PX * scale

    return { height, width, borderRadius }
}

const useCabinMediaPanelSize = (isOpen: boolean): CabinMediaPanelSize => {
    const [panelSize, setPanelSize] = useState(getPanelSize)

    useEffect(() => {
        if (!isOpen) return

        const handleResize = () => setPanelSize(getPanelSize())

        handleResize()
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [isOpen])

    return panelSize
}

export default useCabinMediaPanelSize
